import React from 'react';

export default function AdditionalInformation() {
  return (
    <div className="ra">
      <br />
      <h1 className="ai">Additional Information</h1>
      <ul>
        <li>
          <h2 className="ai">
            {' '}
            <a
              href={process.env.REACT_APP_AUDITOR_ADDITIONALINFO}
              target="_blank"
              rel="noreferrer"
              aria-label="eAlerts Overview on Auditor's Website"
            >
              eAlerts Overview
            </a>
          </h2>
        </li>
      </ul>
    </div>
  );
}
